import Booking from '../Components/Booking/Booking';
import SEO from '../Components/shared/SEO';

const About = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="About Us"
        path="/about"
        description="Serenoly is Nigeria's massage therapist marketplace — verified professionals, real-time matching, and escrow-protected payments for home, hotel, and spa sessions."
      />
      {/* Hero Section */}
      <div className="relative h-[200px] sm:h-[300px] w-full">
        <div className="absolute inset-0">
          <img
            src={'/static/images/pagesBg/about.jpg'}
            alt="Massage therapy room"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>
        <div className="relative h-full flex items-center justify-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl text-white font-semibold text-center px-4">
            About Serenoly
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="space-y-6 sm:space-y-8 sm:px-8 -mt-8 pt-2 md:pt-0">
          <p className="text-base sm:text-lg text-dim-light px-4 sm:px-0">
            <span className="font-semibold">Serenoly</span> is a two-sided marketplace that connects
            clients with verified, professional massage therapists &mdash; at home, in a hotel room, or at
            a partner spa. Tell us what you need and where you'll be, and our real-time matching
            system pairs you with the best available therapist for your session, on your schedule.
          </p>

          <p className="text-base sm:text-lg text-dim-light px-4 sm:px-0">
            Every payment is held securely in escrow until both you and your therapist confirm the
            session is complete, so you only pay for the care you actually receive. We also partner
            with hotels, guesthouses, and spas to offer bookable rooms alongside your massage, and we
            work with independent massage therapists who go through an admin-reviewed verification
            process before they can accept bookings on the platform.
          </p>

          <p className="text-base sm:text-lg text-dim-light px-4 sm:px-0">
            At <span className="font-semibold">Serenoly</span>, self-care is more than a routine,
            it's a lifestyle &mdash; and we've built the platform to make finding trustworthy,
            professional massage therapy simple, safe, and reliable.
            <span className="italic"> Your journey to relaxation and recovery begins here.</span>
          </p>
        </div>

        {/* Booking Component */}
        <div className="mt-8 sm:mt-16">
          <Booking />
        </div>
      </div>
    </div>
  );
};

export default About;